import {Input} from "../Form/types";
import {createTextInput} from "../Form/Input";
import {__} from "@wordpress/i18n";

export const InputAvailableFrom = (el: HTMLElement|null) => {
    return el
        ? createTextInput( el as HTMLInputElement, ( input: Input, value: string ): void => {
            if ( ! value ) {
                input.addError( __( 'Trage ein Datum ein.', 'dierck-group-company' ) );
                return;
            }

            const selectedDate = new Date( value );
            selectedDate.setHours(0, 0, 0, 0);

            const today = new Date();
            today.setHours(0, 0, 0, 0);

            if (Number.isNaN(selectedDate.getTime())) {
                input.addError( __( 'Ungültiges Datum.', 'dierck-group-company' ) );
                return;
            }

            if ( selectedDate.getTime() <= today.getTime() ) {
                input.addError( __( 'Das Datum muss in der Zukunft liegen.', 'dierck-group-company' ) );
                return;
            }
        } )
        : null;
}
